import {hasFeatureFlag} from './FeatureUtil';

/**
 * Whether the current company is a Jira customer, i.e. has either the Jira Cloud
 * or the Jira Server integration enabled. Used to keep Jira customers on the
 * legacy editor while the Plate JS editor rolls out (PIKA-541).
 */
export function isJiraCustomer(company) {
	return !!(company && (company.jiraCloudEnabled || company.jiraServerEnabled));
}

export function isJiraToForecastOneWaySync(company) {
	if (!hasFeatureFlag('jira_to_forecast_one_way_sync')) {
		return false;
	}

	if (company.jiraCloudEnabled) {
		return company.integrations.jiraCloud.syncSettings.isJiraToForecastOneWaySync;
	} else if (company.jiraServerEnabled) {
		return company.integrations.jiraServer.syncSettings.isJiraToForecastOneWaySync;
	} else {
		return false;
	}
}
